import React from "react";
// Component Imports
import QuickReview from "./QuickReview";
import QuickReviewUpgrade from "./QuickReviewUpgrade";
import { FeatureGating } from "../../commonComponents";
// Internal Imports
import { FEATURES } from "../../constants";
// Destructuring
const { FEATURES_NAME } = FEATURES;

export default function (props) {
  return (
    <FeatureGating
      name={FEATURES_NAME.METALENS}
      altComponent={<QuickReviewUpgrade {...props} />}>
      {" "}
      <QuickReview {...props} />{" "}
    </FeatureGating>
  );
}
